export async function getGeoLocation() {
  try {
    const response = await fetch('https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation');
    if (!response.ok) {
      throw new Error('Failed to fetch location');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching geolocation:', error);
    return null;
  }
}
